import { useEffect, useState } from 'react'
import styles from './ScoopFormat.module.scss'
import { getFormatter } from '../../Insights/KPI/utils'
import { ScoopSelector, ScoopText, ScoopTextField } from '..'

const TYPE_OPTIONS = [
    { value: 'number', label: 'Number' },
    { value: 'currency', label: 'Currency' },
    { value: 'percentage', label: 'Percentage' },
]

export const ScoopFormat = ({ format, onChange }) => {
    const [formatObject, setFormatObject] = useState({
        type: 'number',
        decimals: 0,
        symbol: '$',
        short: false,
    })
    const [testValue, setTestValue] = useState(0)
    const [currentFormat, setCurrentFormat] = useState('')

    useEffect(() => {
        if (format) {
            const tempFormat = {
                type: 'number',
                decimals: 0,
                symbol: '$',
                short: false,
            }
            if (format.includes('%')) tempFormat.type = 'percentage'
            if (format.includes('$')) tempFormat.type = 'currency'
            if (format.includes('.')) {
                const decimals = format.split('.')[1]
                tempFormat.decimals = decimals.replace(/\D/g, '').length
            } else {
                tempFormat.decimals = 0
            }
            if (format.includes('a')) tempFormat.short = true
            setFormatObject(tempFormat)
            setCurrentFormat(format)
        }
    }, [format])

    const getDecimals = (d) => {
        if (d > 0) return '.' + '0'.repeat(d)
        return ''
    }

    const handleFormatChange = (prop, value) => {
        const newFormat = { ...formatObject }
        newFormat[prop] = value
        let formatString = ''
        switch (newFormat.type) {
            case 'number':
                if (newFormat.short) formatString = '#,###' + getDecimals(newFormat.decimals) + 'K'
                else formatString = '#,###' + getDecimals(newFormat.decimals)
                break
            case 'currency':
                if (newFormat.short)
                    formatString =
                        newFormat.symbol + '#,###' + getDecimals(newFormat.decimals) + 'K'
                else formatString = newFormat.symbol + '#,###' + getDecimals(newFormat.decimals)
                break
            case 'percentage':
                formatString = '#,###' + getDecimals(newFormat.decimals) + '%'
                break
            default:
                break
        }
        setCurrentFormat(formatString)
        setFormatObject(newFormat)
        onChange(formatString)
    }

    return (
        <div className={styles.container}>
            <div className={styles.sectionContainer}>
                <ScoopSelector
                    label={'Type'}
                    value={formatObject.type}
                    onChange={(e) => handleFormatChange('type', e.target.value)}
                    options={TYPE_OPTIONS}
                    removeMargin
                />
            </div>
            <ScoopTextField
                label={'Decimals'}
                value={formatObject.decimals}
                onChange={(event) => {
                    const value = event.target.value
                    handleFormatChange('decimals', value >= 0 ? value : 0)
                }}
                type={'number'}
            />
            <ScoopTextField
                label={'Format string'}
                value={currentFormat}
                onChange={(event) => setCurrentFormat(event.target.value)}
            />
            <ScoopTextField
                label={'Test'}
                value={testValue}
                onChange={(event) => setTestValue(event.target.value)}
            />
            <ScoopTextField
                label={'Result'}
                value={getFormatter(currentFormat).format(testValue)}
                disabled={true}
            />
        </div>
    )
}
